import IconCarTraction4x4 from '@adv-mt/mt-svg-icons/lib/CarTraction4x4.js'
import IconCarTractionfwd from '@adv-mt/mt-svg-icons/lib/CarTractionfwd.js'
import IconCarTractionrwd from '@adv-mt/mt-svg-icons/lib/CarTractionrwd.js'

const DRIVEN_WHEELS = {
  ALL: 1,
  FRONT: 3,
  REAR: 4
}

export const ICONS_BY_DRIVEN_WHEEL = {
  [DRIVEN_WHEELS.ALL]: IconCarTraction4x4,
  [DRIVEN_WHEELS.FRONT]: IconCarTractionfwd,
  [DRIVEN_WHEELS.REAR]: IconCarTractionrwd
}
